export const ADMIN_LIST_QUERY_KEY = ["admins"];
export const ADMIN_PERMISSION_QUERY_KEY = ["admins", "permissions"];
